import { CONTACT_DETAILS, FOOTER } from '@/dictionary/common';
import { DEPARTMENT_ORDER, DEPARTMENTS } from '@/dictionary/departments';
import { HOME_ANCHORS, ROUTES } from '@/dictionary/routes';
import { Link } from 'react-router-dom';
import classes from './SiteFooter.module.css';

const departmentsAnchor = `${ROUTES.home}${HOME_ANCHORS.departments}`;
const aboutAnchor = `${ROUTES.home}${HOME_ANCHORS.about}`;

export function SiteFooter() {
  return (
    <footer className={classes.footer}>
      <div className={classes.inner}>
        <div className={classes.columns}>
          <div>
            <h2 className={classes.title}>{FOOTER.departmentsTitle}</h2>
            <ul className={classes.list}>
              {DEPARTMENT_ORDER.map((slug) => (
                <li key={slug}>
                  <Link to={departmentsAnchor} className={classes.link}>
                    {DEPARTMENTS[slug].title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className={classes.title}>{FOOTER.aboutTitle}</h2>
            <ul className={classes.list}>
              <li>
                <Link to={ROUTES.advisors} className={classes.link}>
                  {FOOTER.aboutLinks.advisors}
                </Link>
              </li>
              <li>
                <Link to={aboutAnchor} className={classes.link}>
                  {FOOTER.aboutLinks.who}
                </Link>
              </li>
              <li>
                <Link to={aboutAnchor} className={classes.link}>
                  {FOOTER.aboutLinks.vision}
                </Link>
              </li>
              <li>
                <Link to={aboutAnchor} className={classes.link}>
                  {FOOTER.aboutLinks.team}
                </Link>
              </li>
              <li>
                <Link to={ROUTES.terms} className={classes.link}>
                  {FOOTER.aboutLinks.terms}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className={classes.title}>{FOOTER.contactTitle}</h2>
            <ul className={classes.list}>
              <li>
                <a href={CONTACT_DETAILS.phoneHref} className={classes.link} dir="ltr">
                  {CONTACT_DETAILS.phone}
                </a>
              </li>
              <li>
                <a href={CONTACT_DETAILS.emailHref} className={classes.link} dir="ltr">
                  {CONTACT_DETAILS.email}
                </a>
              </li>
              <li>
                <span className={classes.link}>{CONTACT_DETAILS.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <p className={classes.copyright}>{FOOTER.copyright}</p>
      </div>
    </footer>
  );
}
